/** Normalize UI property-type id (e.g. homepage "guest house" → "guesthouse") */
export const normalizePropertyTypeId = (type) => {
  if (!type || type === 'all') return 'all';
  const t = String(type).toLowerCase().trim();
  if (t === 'guest house') return 'guesthouse';
  const valid = [
    'hotel',
    'villa',
    'homestay',
    'pg',
    'resort',
    'apartment',
    'guesthouse',
    'other',
    'meeting room',
  ];
  return valid.includes(t) ? t : 'all';
};

/** Map UI id to API `category` query param */
export const getCategoryQueryValue = (type) => {
  if (!type || type === 'all' || type === 'meeting room') return '';
  const id = normalizePropertyTypeId(type);
  const map = {
    guesthouse: 'guesthouse',
    pg: 'pg',
    villa: 'villa',
    apartment: 'apartment',
    hotel: 'hotel',
    homestay: 'homestay',
    resort: 'resort',
    other: 'other',
  };
  return map[id] || id;
};

/** True when a hotel/stay row belongs to the selected property type */
export const hotelMatchesPropertyType = (hotel, propertyTypeId) => {
  const selected = normalizePropertyTypeId(propertyTypeId);
  if (selected === 'all' || selected === 'meeting room') return true;

  const hotelType = String(hotel?.type || 'Hotel').toLowerCase();

  if (selected === 'hotel') return hotelType.includes('hotel');
  if (selected === 'villa') return hotelType.includes('villa');
  if (selected === 'homestay') return hotelType.includes('homestay');
  if (selected === 'pg') {
    return (
      hotelType.includes('pg') ||
      hotelType.includes('hostel') ||
      hotelType.includes('paying guest')
    );
  }
  if (selected === 'resort') return hotelType.includes('resort');
  if (selected === 'apartment') {
    return hotelType.includes('apartment') || hotelType.includes('flat');
  }
  if (selected === 'guesthouse') {
    return hotelType.includes('guesthouse') || hotelType.includes('guest house');
  }
  if (selected === 'other') {
    return (
      hotelType.includes('other') ||
      !/hotel|villa|homestay|hostel|pg|resort|apartment|guesthouse/.test(hotelType)
    );
  }

  return hotelType.includes(selected);
};
